module.exports = __webpack_public_path__ + "img/call_missed.01089e31.svg";